import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import TransactionTable from './TransactionTable';
import { TransactionContext } from '../transactionContext';

const IndexList = ({ setFilters, showBankAccount, loading }) => {
  const { transactions } = useContext(TransactionContext);

  const handleTableChange = (pagination, filters) => {
    setFilters({
      dateRange: (filters.created_at || null),
    });
  };

  // hack to hide some transactions temporarily as we cannot delete them from the
  // db and we don't want them to be seen for the time being.
  const filterHiddenTransactions = (txs) => {
    const hideIDs = [
      '2021-06-d0232ec4-b2a3-4dc6-b56e-03390fd8b720',
      '2021-06-9d760f02-0736-40bf-90d7-c709c0a09d41',
      '2021-06-df2748eb-e0f9-41d0-acbe-9ca1575ff34c',
      '2021-06-51e340b6-52ee-42c7-99f9-6b7df247ba17',
    ];

    return txs.filter(({ id }) => hideIDs.indexOf(id) === -1);
  };

  return (
    <TransactionTable
      transactions={filterHiddenTransactions(transactions)}
      onChange={handleTableChange}
      showBankAccount={showBankAccount}
      loading={loading && !transactions.length}
    />
  );
};

IndexList.propTypes = {
  setFilters: PropTypes.func,
  showBankAccount: PropTypes.bool,
  loading: PropTypes.bool,
};

export { IndexList };
